import { render, staticRenderFns } from "./SendMailTemplatePicker.vue?vue&type=template&id=17c19869&"
import script from "./SendMailTemplatePicker.vue?vue&type=script&lang=js&"
export * from "./SendMailTemplatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports